module.exports = __webpack_public_path__ + "img/icon10.aa5dd034.svg";